import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type ChatSearchState = {
  value: string;
  unread: boolean;
  isActive: boolean;
  showMentionedMessages: boolean;
  sortByNewest: boolean | null;
  showUnrepliedMessages: boolean;
  showAIChannels: boolean;
  showOnlyAdminMessage: boolean;
};

const initialState: ChatSearchState = {
  value: "",
  unread: false,
  isActive: false,
  showMentionedMessages: false,
  sortByNewest: null,
  showUnrepliedMessages: false,
  showAIChannels: false,
  showOnlyAdminMessage: true,
};

export const chatSearch = createSlice({
  name: "chatSearch",
  initialState,
  reducers: {
    setSearch: (state, action: PayloadAction<string>) => {
      state.value = action.payload;
    },
    setUnreadFilter: (state, action: PayloadAction<boolean>) => {
      state.unread = action.payload;
    },
    setSearchActiveState: (state, action: PayloadAction<boolean>) => {
      state.isActive = action.payload;
    },
    setShowMentionedMessages: (state, action: PayloadAction<boolean>) => {
      state.showMentionedMessages = action.payload;
    },
    setSortByNewest: (state, action: PayloadAction<boolean | null>) => {
      state.sortByNewest = action.payload;
    },
    setShowUnrepliedMessages: (state, action: PayloadAction<boolean>) => {
      state.showUnrepliedMessages = action.payload;
    },
    setShowAIChannels: (state, action: PayloadAction<boolean>) => {
      state.showAIChannels = action.payload;
    },
    setShowOnlyAdminMessage: (state, action: PayloadAction<boolean>) => {
      state.showOnlyAdminMessage = action.payload;
    },
  },
});

export const {
  setSearch,
  setUnreadFilter,
  setSearchActiveState,
  setShowMentionedMessages,
  setSortByNewest,
  setShowUnrepliedMessages,
  setShowAIChannels,
  setShowOnlyAdminMessage,
} = chatSearch.actions;

export default chatSearch.reducer;
